
import { mapGetters } from "vuex";
import Vue from "vue";
import OAuthService from "@/services/OAuthService";

export default Vue.extend({
  name: "SettingsModal",
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    presetSettings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("navigation", ["globalCenter"]),
  },
  data() {
    return {
      isVisible: true,
      valid: false,
      settings: { ...this.presetSettings },
      webhookUrl: "", // Stores the fetched webhook URL
      gmailAliases: [] as string[], // Holds available Gmail aliases
    };
  },
  async mounted() {
    // For Gmail, fetch the available aliases so the user can select one.
    if (this.vendor.vendor === "GMAIL") {
      try {
        // Replace with your actual service call to fetch Gmail aliases.
        this.gmailAliases = await OAuthService.getGmailAliases(this.globalCenter.accountId);
      } catch (error) {
        console.error("Failed to fetch Gmail aliases", error);
      }
    }
    // If the vendor is AUTHORIZE_NET, fetch the webhook URL.
    if (this.vendor.vendor === "AUTHORIZE_NET") {
      try {
        this.webhookUrl = await OAuthService.getWebhookUrl(this.globalCenter.accountId);
      } catch (error) {
        console.error("Failed to fetch webhook URL", error);
      }
    }
  },
  methods: {
    /**
     * Formats a camelCase key into Title Case.
     * E.g., "fromEmail" becomes "From Email".
     */
    formatKey(key: string): string {
      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
    },
    /**
     * Returns vendor-specific instructions for each key.
     */
    getHint(key: string): string {
      if (this.vendor.vendor === "AUTHORIZE_NET") {
        if (key === "apiLoginId") {
          return "Enter your API Login ID from your Authorize.Net Merchant Interface (Account > Settings > API Credentials and Keys).";
        } else if (key === "transactionKey") {
          return "Enter your Transaction Key from your Authorize.Net Merchant Interface (Account > Settings > API Credentials and Keys).";
        } else if (key === "signatureKey") {
          return "Enter your Signature Key found under Account > Settings > Security Settings > General Security Settings.";
        }
      } else if (this.vendor.vendor === "GMAIL") {
        if (key === "fromEmail") {
          return "Log into your Gmail account and navigate to Settings > Accounts and Import (or Accounts in some versions). Under 'Send mail as', check if all the aliases you expect are listed. If not, add and verify them.";
        }
      }
      return "";
    },
    saveSettings() {
      // Since the fields are not required, simply emit the current settings.
      this.$emit("save", this.settings);
    },
  },
});
